import { Table, TableColumnsType } from "antd";
import { FC, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import exportTable from "../../../lib/exportTable";
import { IEnrolledStudentLevel } from "../../../models/statistics.model";
import DownloadButton from "../../DownloadButton";
import moment from "moment";
import useUtil from "../../../hooks/useUtil";

interface IProps {
  res: any;
  pEduStepCode: any;
  searchClick: any;
}

const Level: FC<IProps> = ({
  res,
  pEduStepCode,
  searchClick
}) => {
  const { t } = useTranslation();
  const { getCommonCodeLabel } = useUtil();

  const [data, setData] = useState<IEnrolledStudentLevel[]>([]);
  const [eduStepCode, setEduStepCode] = useState<string>();

  useEffect(() => {
    if(searchClick) {
      setEduStepCode(pEduStepCode);
    }
  }, [searchClick]);

  useEffect(() => {
    if (res) {
      // @ts-ignore
      const _data: IEnrolledStudentLevel[] = [];
      let idxCount = 0;
      let firstRowCheck = false;

      res.forEach((item: any) => {
        if(item.courseCode === 0) {
          item.courseName = t('entrance.statistics.row1');
          firstRowCheck = true;
        } else {
          item.k7Count = item.k7Count === 0 ? ' ' : item.k7Count;
          item.e1Count = item.e1Count === 0 ? ' ' : item.e1Count;
          item.e2Count = item.e2Count === 0 ? ' ' : item.e2Count;
          item.e3Count = item.e3Count === 0 ? ' ' : item.e3Count;
          item.e4Count = item.e4Count === 0 ? ' ' : item.e4Count;
          item.e5Count = item.e5Count === 0 ? ' ' : item.e5Count;
          item.e6Count = item.e6Count === 0 ? ' ' : item.e6Count;
          item.m1Count = item.m1Count === 0 ? ' ' : item.m1Count;
          item.m2Count = item.m2Count === 0 ? ' ' : item.m2Count;
          item.m3Count = item.m3Count === 0 ? ' ' : item.m3Count;
          item.h1Count = item.h1Count === 0 ? ' ' : item.h1Count;
        }

        if(firstRowCheck === false) {
          //합계 row가 없는 경우 전체 레벨분포 Count 없음으로 빈 테이블 처리
          return false;
        }

        item.rowIdx = idxCount;
        idxCount++;
        _data.push(item);
        
        if(item.courseCode === 0) {
          const gradePercent: any = {
            rowIdx: idxCount,
            courseCode: 0,
            courseName: t('statistics.studentEnroll.row1'),
            k7Count: Math.floor((item.k7Count / item.totCount) * 1000) / 10 + '%',
            e1Count: Math.floor((item.e1Count / item.totCount) * 1000) / 10 + '%',
            e2Count: Math.floor((item.e2Count / item.totCount) * 1000) / 10 + '%',
            e3Count: Math.floor((item.e3Count / item.totCount) * 1000) / 10 + '%',
            e4Count: Math.floor((item.e4Count / item.totCount) * 1000) / 10 + '%',
            e5Count: Math.floor((item.e5Count / item.totCount) * 1000) / 10 + '%',
            e6Count: Math.floor((item.e6Count / item.totCount) * 1000) / 10 + '%',
            m1Count: Math.floor((item.m1Count / item.totCount) * 1000) / 10 + '%',
            m2Count: Math.floor((item.m2Count / item.totCount) * 1000) / 10 + '%',
            m3Count: Math.floor((item.m3Count / item.totCount) * 1000) / 10 + '%',
            h1Count: Math.floor((item.h1Count / item.totCount) * 1000) / 10 + '%',
            totCount: Math.floor((item.totCount / item.totCount) * 1000) / 10 + '%'
          }
          _data.push(gradePercent);
          idxCount++;
        }
      });
 
      setData(_data);
    }
  }, [res]);

  const onExportTable = () => {
    const currentDate = moment(new Date());
    exportTable(getColumns(), data, `${t('statistics.studentEnroll.title1')}(${t('statistics.studentEnroll.tab2')})_(${currentDate.format('YYYYMMDD')})`, t('statistics.studentEnroll.tab2'), [17, 12, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]);
  }

  const getColumns = () => {
    let tempColumns: any = [];
    let columns: TableColumnsType<IEnrolledStudentLevel> = [];
    let arrRemoveGrade: String[] = [];

    if(eduStepCode === 'EM') {
      arrRemoveGrade = ["m1Count","m2Count","m3Count","h1Count"];
    } else if(eduStepCode === 'MD') {
      arrRemoveGrade = ["k7Count", "e1Count", "e2Count", "e3Count", "e4Count", "e5Count","h1Count"];
    }

    tempColumns = [
      {
        title: t('student.student.column26'),
        dataIndex: 'courseName',
        key: 'courseName',
        align: 'center',
      },
      {
        title: getCommonCodeLabel('SY0006', 'K7'),
        dataIndex: 'k7Count',
        key: 'k7Count',
        align: 'center',
      },
      {
        title: t('statistics.studentEnrolled.e1'),
        dataIndex: 'e1Count',
        key: 'e1Count',
        align: 'center',
      },
      {
        title: t('statistics.studentEnrolled.e2'),
        dataIndex: 'e2Count',
        key: 'e2Count',
        align: 'center',
      },
      {
        title: t('statistics.studentEnrolled.e3'),
        dataIndex: 'e3Count',
        key: 'e3Count',
        align: 'center',
      },
      {
        title: t('statistics.studentEnrolled.e4'),
        dataIndex: 'e4Count',
        key: 'e4Count',
        align: 'center',
      },
      {
        title: t('statistics.studentEnrolled.e5'),
        dataIndex: 'e5Count',
        key: 'e5Count',
        align: 'center',
      },
      {
        title: t('statistics.studentEnrolled.e6'),
        dataIndex: 'e6Count',
        key: 'e6Count',
        align: 'center',
      },
      {
        title: getCommonCodeLabel('SY0006', '07'),
        dataIndex: 'm1Count',
        key: 'm1Count',
        align: 'center',
      },
      {
        title: getCommonCodeLabel('SY0006', '08'),
        dataIndex: 'm2Count',
        key: 'm2Count',
        align: 'center',
      },
      {
        title: getCommonCodeLabel('SY0006', '09'),
        dataIndex: 'm3Count',
        key: 'm3Count',
        align: 'center',
      },
      {
        title: getCommonCodeLabel('SY0006', '10'),
        dataIndex: 'h1Count',
        key: 'h1Count',
        align: 'center',
      },
      {
        title: t('entrance.statistics.row1'),
        dataIndex: 'totCount',
        key: 'totCount',
        align: 'center',
      },
    ]

    columns = tempColumns.filter((item : any, index : number, arr : any)=>{
      return arrRemoveGrade.indexOf(item.key) === -1;  
    });
    
    return columns;
  }

  return (
    <>
      <div className="comm-table__area">
        <Table
          columns={getColumns()}
          dataSource={data}
          pagination={{
            current: 1,
            pageSize: 999999999,
          }}
          rowClassName={(record: IEnrolledStudentLevel) => record.courseCode === 0 ? 'tfoot' : ''}
          rowKey={'rowIdx'}
        />
      </div>
      <div className="comm-bx__space">
        <DownloadButton onClick={onExportTable} />
      </div>
    
    </>
  );
}

export default Level;
